export default __webpack_public_path__ + "static/media/category-2.e3c09e98.svg";